import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {BsDatepickerConfig, BsDatepickerDirective} from 'ngx-bootstrap/datepicker';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import {finalize, Subject, takeUntil} from 'rxjs';
import {CotacaoLeadService} from 'src/app/api/module/erp/services/area-logada/cotacao-lead/cotacao-lead.service';
import {jwtAuthService} from 'src/app/api/module/erp/services/auth/jwtAuthService';
import {TipoProduto_E_OperadoraComponent} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import {CampoDataService} from 'src/app/api/module/erp/shared/services/campoData/campo-data.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
@Component({
  selector: 'app-cotacao-visualizar',
  templateUrl: './cotacao-visualizar.component.html',
  styleUrls: ['./cotacao-visualizar.component.scss'],
})
export class CotacaoVisualizarComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  listaModal: any;
  filtroRede: string = '';

  compartilharLink() {
    throw new Error('Method not implemented.');
  }
  @ViewChild('datepicker', {static: false}) datepicker?: BsDatepickerDirective;
  @ViewChild('modalMaisInformacoes') modalMaisInformacoes: any;

  inputDataSelecionado: boolean = false;
  listaCotacaoVisualizaVM: Array<any> = [];
  listaEnumTipoCotacao: any;
  idCotacao: any;
  dados: any;
  gruposPorIdade: any;
  totalGeralVidas: number = 0;
  desabilitarBtn: boolean = false;
  preLeadId: any;
  totalLaboratorios: number = 0;
  totalHospitais: number = 0;
  tipoProduto: number = 0;

  deveAbrirModal = false;
  bsConfig: Partial<BsDatepickerConfig>;
  minDate!: Date;
  maxDate: Date;

  dataNascimento: any = '';
  erroDataNascimento: boolean = false;
  modalAuthDataNascimentoRef!: BsModalRef;
  modalInformacoes!: BsModalRef;
  @ViewChild('modalAuthDataNascimento')
  modalAuthDataNascimento: any;
  @ViewChild('modalLink') modalLink: any;
  modalLinkRef?: BsModalRef;
  urlAtual: string = '';
  linkCopiado: boolean = false;
  estaLogado: boolean = false;
  @ViewChild('redeCredenciada') redeCredenciada!: TemplateRef<any>;
  modalRedeRef: any;
  logoOperadora: any;
  redesParaImprimir: any[] = [];

  constructor(
    private _activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private _cotacaoLeadService: CotacaoLeadService,
    private router: Router,
    private _spinnerService: SpinnerService,
    private jwt: jwtAuthService,
    private _errorLogging: ErrorLoggingService,
    private _modalService: BsModalService,
    private _campoDataService: CampoDataService,
  ) {
    this.maxDate = new Date();
    this.bsConfig = {
      isAnimated: true,
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      adaptivePosition: true,
      maxDate: new Date(),
    };
  }

  ngAfterViewInit(): void {
    this.recuperarIdCotacao();
    if (this.deveAbrirModal) {
      this.abrirModalAniversario();
    }
  }

  ngOnInit(): void {
    this.buscarCotacaoLead();
    if (this.jwt.isUsuarioLogado()) this.estaLogado = true;
    if (!this.validacaoEstaAtiva()) {
      this.verificarAniversario();
    } else {
      this.deveAbrirModal = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  errorLogs(erro: any, mensagemErro: any, contexto: string, data: any): void {
    this._errorLogging.logError(mensagemErro, erro, {
      contexto: contexto,
      data: {
        data,
      },
    });
  }
  verificarAniversario(): void {
    // this.buscarCotacaoLead();
    // Primeiro verifica se já existe uma validação ativa
    if (this.validacaoEstaAtiva()) {
      this.deveAbrirModal = false;
      return;
    }

    // Se não tiver validação ativa, verifica se está logado(colaborador)
    if (!this.jwt.isUsuarioLogado()) {
      this.deveAbrirModal = true;
    } else {
      this.deveAbrirModal = false;
    }
  }
  voltar() {
    let idLead = this.preLeadId;
    this.router.navigate(['lead/visualizar/'], {queryParams: {idLead}});
  }

  agruparPorIdade(holderQuote: any): any[] {
    const agrupados: {
      descricaoGrupoPorIdade: string;
      totalVida: number;
      valorTotalVidas: number;
    }[] = [];

    const calcularIdade = (dataNascimento: string): number => {
      const hoje = new Date();
      const nascimento = new Date(dataNascimento);
      let idade = hoje.getFullYear() - nascimento.getFullYear();
      const mes = hoje.getMonth() - nascimento.getMonth();

      if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--;
      }
      return idade;
    };

    const descricaoValida = (descricao: string): boolean => {
      return /^\d+\s*a\s*\d+\s*anos$/.test(descricao); // valida somente de vir no farmato numero a numero (0 a 18  por exempo)
    };

    // Adiciona o titular (holderQuote) ao agrupamento
    let groupDescription = holderQuote.agesGroupDescription;
    if (!descricaoValida(groupDescription) && holderQuote.birthDate) {
      // const idadeTitular = calcularIdade(holderQuote.birthDate);
      groupDescription = groupDescription || '-';
    }

    // Tenta encontrar um grupo existente para o titular
    let existingGroup = agrupados.find(group => group.descricaoGrupoPorIdade === groupDescription);
    if (existingGroup) {
      existingGroup.totalVida += 1;
      existingGroup.valorTotalVidas += holderQuote.priceValue;
    } else {
      agrupados.push({
        descricaoGrupoPorIdade: groupDescription,
        totalVida: 1,
        valorTotalVidas: holderQuote.priceValue,
      });
    }

    // Adiciona os dependentes ao agrupamento
    if (holderQuote.dependentsQuotes) {
      holderQuote.dependentsQuotes.forEach((dependent: any) => {
        let groupDescription = dependent.agesGroupDescription;

        // Verifica se a descrição é válida; caso contrário, calcula o grupo pelo `birthDate`
        if (!descricaoValida(groupDescription) && dependent.birthDate) {
          const idadeDependente = calcularIdade(dependent.birthDate);
          groupDescription = groupDescription || '-';
        }

        // Tenta encontrar um grupo existente para o dependente
        existingGroup = agrupados.find(group => group.descricaoGrupoPorIdade === groupDescription);
        if (existingGroup) {
          existingGroup.totalVida += 1;
          existingGroup.valorTotalVidas += dependent.priceValue;
        } else {
          agrupados.push({
            descricaoGrupoPorIdade: groupDescription,
            totalVida: 1,
            valorTotalVidas: dependent.priceValue,
          });
        }
      });
    }

    return agrupados.sort((a: {descricaoGrupoPorIdade: string}, b: {descricaoGrupoPorIdade: string}) => {
      // Extrai o primeiro número de cada descrição
      const extrairIdade = (descricao: string): number => {
        if (!descricao) return 0;
        // Para formato "0 a 18 anos" ou "0-18 anos" ou "0 a 18"
        const match = descricao.match(/^(\d+)/);
        return match ? parseInt(match[1], 10) : 0;
      };

      const idadeA = extrairIdade(a.descricaoGrupoPorIdade);
      const idadeB = extrairIdade(b.descricaoGrupoPorIdade);

      return idadeA - idadeB; // Ordem crescente
    });
  }

  totalVidaGeral(objVidas: any[]): number {
    const totalDependentes = objVidas.reduce((total, cotacao) => total + cotacao.totalVidas, 0);
    return totalDependentes + 1; // total dependentes da lista + um titular
  }

  buscarCotacaoLeadOLD() {
    try {
      this.iniciarSpinner();
      let idGrupoDaCotacao = this.recuperarIdCotacao();

      this._cotacaoLeadService
        .listarCotacaoPorId(idGrupoDaCotacao)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.pararSpinner();
          }),
        )
        .subscribe({
          next: dataDM => {
            this.dados = dataDM && dataDM;
            this.preLeadId = dataDM?.preLeadId;

            this.montarPDFView(dataDM);
          },
          error: err => {
            this.errorLogs(
              err,
              'Erro ao buscar cotação lead (OLD)',
              'CotacaoVisualizarComponent.buscarCotacaoLeadOLD',
              { idGrupoDaCotacao },
            );
          },
        });
    } catch (error) {}
  }

  buscarCotacaoLead() {
    try {
      this.iniciarSpinner();

      // DADOS MOCKADOS PARA TESTE
      const mockData = {
        id: '123e4567-e89b-12d3-a456-426614174000',
        preLeadId: 'prelead-123',
        responsibleUserName: 'Administrador do sistema',
        prices: [
          {
            productName: 'BASICO ENFERMARIA - ESTADUAL',
            branchCompanyName: 'ABRAWEB',
            productTypeName: 'Saúde',
            modalityProductName: 'Coletivo Adesão',
            accommodationName: 'A-Enfermaria',
            coparticipation: false,
            totalPriceValue: 457.01,
            operatorURLImage: 'assets/logo-operadora.png',
            holderQuote: {
              name: 'TEste Novo item',
              email: 'teste@gmail.com',
              telephone: '(11) 99999-9999',
              agesGroupDescription: '29 a 33 anos',
              priceValue: 457.01,
              dependentsQuotes: [],
            },
            hospitalsInZone: [
              {
                cityName: 'São Paulo',
                stateName: 'SP',
                hospitals: [{name: 'Hospital A'}, {name: 'Hospital B'}],
                zones: [
                  {
                    zone: 'Zona Sul',
                    hospitals: [{name: 'Hospital C'}, {name: 'Hospital D'}],
                  },
                  {
                    zone: 'Zona Norte',
                    hospitals: [{name: 'Hospital E'}],
                  },
                ],
              },
              {
                cityName: 'Rio de Janeiro',
                stateName: 'RJ',
                hospitals: [{name: 'Hospital F'}],
                zones: [],
              },
            ],
            laboratories: [
              {name: 'Laboratório A'},
              {name: 'Laboratório B'},
              {name: 'Laboratório C'},
              {name: 'Laboratório D'},
              {name: 'Laboratório E'},
            ],
          },
          {
            productName: 'PREMIUM - NACIONAL',
            branchCompanyName: 'ABRAWEB',
            productTypeName: 'Saúde',
            modalityProductName: 'Coletivo Adesão',
            accommodationName: 'Apartamento',
            coparticipation: true,
            totalPriceValue: 789.0,
            operatorURLImage: 'assets/logo-operadora.png',
            holderQuote: {
              name: 'TEste Novo item',
              email: 'teste@gmail.com',
              telephone: '(11) 99999-9999',
              agesGroupDescription: '29 a 33 anos',
              priceValue: 789.0,
              dependentsQuotes: [],
            },
            hospitalsInZone: [
              {
                cityName: 'São Paulo',
                stateName: 'SP',
                hospitals: [{name: 'Hospital Premium A'}, {name: 'Hospital Premium B'}],
                zones: [
                  {
                    zone: 'Zona Sul',
                    hospitals: [{name: 'Hospital Premium C'}],
                  },
                ],
              },
            ],
            laboratories: [{name: 'Laboratório Premium A'}, {name: 'Laboratório Premium B'}],
          },
          {
            productName: 'ODONTO',
            branchCompanyName: 'ABRAWEB',
            productTypeName: 'Odonto',
            modalityProductName: 'Coletivo Adesão',
            accommodationName: null,
            coparticipation: false,
            totalPriceValue: 245.0,
            operatorURLImage: 'assets/logo-operadora.png',
            holderQuote: {
              name: 'TEste Novo item',
              email: 'teste@gmail.com',
              telephone: '(11) 99999-9999',
              agesGroupDescription: '29 a 33 anos',
              priceValue: 245.0,
              dependentsQuotes: [],
            },
            hospitalsInZone: [],
            laboratories: [{name: 'Laboratório Odonto A'}, {name: 'Laboratório Odonto B'}],
          },
        ],
      };

      let idGrupoDaCotacao = this.recuperarIdCotacao();
      this._cotacaoLeadService
        .listarCotacaoPorId(idGrupoDaCotacao)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => this.pararSpinner()),
        )
        .subscribe({
          next: dataDM => {
            this.dados = dataDM;
            this.preLeadId = dataDM?.preLeadId;
            this.montarPDFView(dataDM);
          },
          error: err => {
            this.errorLogs(
              err,
              'Erro ao buscar cotação lead',
              'CotacaoVisualizarComponent.buscarCotacaoLead',
              { idGrupoDaCotacao },
            );
          },
        });

      // Usando dados mockados
      // setTimeout(() => {
      //   this.dados = mockData;
      //   this.preLeadId = mockData?.preLeadId;
      //   this.montarPDFView(mockData);
      //   this.pararSpinner();
      // }, 500);
    } catch (error) {
      console.error('Erro ao buscar cotação:', error);
      this.pararSpinner();
    }
  }

  montarPDFView(dataDM: any) {
    this.iniciarSpinner();
    this.preLeadId = dataDM?.preLeadId;
    this.tipoProduto = dataDM?.prices[0]?.productType;

    this.logoOperadora = dataDM && dataDM?.prices[0]?.operatorURLImage;

    // Iterar sobre cada preço
    dataDM?.prices.forEach((price: any) => {
      const holderQuote = price.holderQuote;
      const grupoIdade = this.agruparPorIdade(holderQuote); // Agrupar por idade do holderQuote
      this.listaCotacaoVisualizaVM.push({
        pricesGroupId: dataDM.id,
        idCotacao: dataDM.id,
        descricaoIdade: holderQuote.agesGroupDescription || 0,
        totalVidas: holderQuote.dependentsQuotes.length || 0,
        produto: price.productName || '-',
        entidade: price.branchCompanyName || '-',
        modalidade: price.productTypeName + ' - ' + price.modalityProductName || '-',
        valorTotal: price.totalPriceValue || '-',
        acomodacao: price.accommodationName || '-',
        isExpandHospitais: false,
        isExpandValores: false,
        cliente: holderQuote.name || '-',
        telephone: holderQuote.telephone || '(00)00000000',
        email: holderQuote.email || '-',
        corretor: dataDM.responsibleUserName || '-',
        coparticipacao: price.coparticipation ? 'SIM' : 'NÃO',
        hospitalsInZone: price.hospitalsInZone,
        laboratories: price.laboratories,
        valores: grupoIdade,
      });
    });
    this.pararSpinner();
  }

  contarHospitais(listaModal: any): number {
    if (!listaModal?.hospitalsInZone) return 0;

    let total = 0;
    listaModal.hospitalsInZone.forEach((city: any) => {
      // Hospitais sem zone (diretos)
      if (city.hospitals) total += city.hospitals.length;
      // Hospitais com zone
      if (city.zones) {
        city.zones.forEach((zone: any) => {
          if (zone.hospitals) total += zone.hospitals.length;
        });
      }
    });
    return total;
  }

  contarLaboratorios(listaModal: any): number {
    return listaModal?.laboratories?.length || 0;
  }

  // Função para agrupar hospitais por zona e remover duplicados
  enviarWhatsApp() {}
  enviar(destino: string) {
    this.desabilitarBtn = true;
    // Expande as seções de valores e hospitais
    this.toggleAllExpand('isExpandValores');
    this.toggleAllExpand('isExpandHospitais');

    setTimeout(() => {
      const element = document.getElementById('section-visualizar');
      if (element) {
        html2canvas(element).then(canvas => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('l', 'mm', 'a4');
          const margin = 10;
          const imgWidth = 297 - 2 * margin;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
          const pdfOutput = pdf.output('blob'); // Gerar PDF como Blob

          if (destino == 'whatsapp') {
          } else if (destino == 'email') {
            this.enviarCotacaoEmail();
          }
        });
      }
    }, 100);
  }

  enviarCotacaoEmail() {
    this.desabilitarBtn = true;
    this.iniciarSpinner();

    const email = this.listaCotacaoVisualizaVM[0]?.email || '-';
    const nome = this.listaCotacaoVisualizaVM[0]?.cliente || 'Geia';
    const telefone = this.listaCotacaoVisualizaVM[0]?.telephone || '(11)99999999';
    // this.toggleAllExpand('isExpandValores');
    // this.toggleAllExpand('isExpandHospitais');
    const pricesGroupId = this.listaCotacaoVisualizaVM[0]?.pricesGroupId;

    this._cotacaoLeadService
      .enviarCotacaoPorEmail(email, telefone, nome, pricesGroupId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.pararSpinner()),
      )
      .subscribe({
        next: (v: any) => {
          this.toastr.success('E-mail enviado com sucesso');
          this.desabilitarBtn = false;
          this.toggleAllExpand('isExpandValores');
          this.toggleAllExpand('isExpandHospitais');
        },
        error: (e: any) => {
          this.pararSpinner();
          this.errorLogs(
            e,
            'Erro ao enviar cotação por e-mail',
            'CotacaoVisualizarComponent.enviarCotacaoEmail',
            { email, telefone, nome, pricesGroupId },
          );
          this.toastr.toastrConfig.preventDuplicates = true;
          const mensagemTratada = e.message.replace('Error:', '');
          if (mensagemTratada.includes('[object Object]')) {
            this.toastr.error(mensagemTratada);
          } else {
            this.toastr.error('Erro ao enviar o email');
          }
          this.desabilitarBtn = false; // Reabilita o botão em caso de erro
        },
      });
  }

  async imprimirOLD() {
    this.iniciarSpinner();

    this.toggleAllExpand('isExpandValores');
    this.toggleAllExpand('isExpandHospitais');

    setTimeout(() => {
      const element = document.getElementById('section-visualizar');
      if (!element) {
        this.pararSpinner();
        return;
      }

      html2canvas(element, {scale: 2}).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        this.toggleAllExpand('isExpandValores');
        this.toggleAllExpand('isExpandHospitais');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = 210;
        const pageHeight = 297;

        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * pageWidth) / canvas.width;

        let position = 0;
        let heightLeft = imgHeight;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
          pdf.addPage();
          position = heightLeft - imgHeight;
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save(`cotacao_${this.listaCotacaoVisualizaVM[0]?.cliente}_${new Date().toISOString().slice(0, 10)}.pdf`);

        setTimeout(() => this.pararSpinner(), 500);
      });
    }, 300);
  }

  toggleAllExpand(property: string) {
    const shouldExpand = !this.isAnyExpanded(property);
    this.listaCotacaoVisualizaVM && this.listaCotacaoVisualizaVM.forEach(row => (row[property] = shouldExpand));
  }

  isAnyExpanded(property: string): boolean {
    return this.listaCotacaoVisualizaVM && this.listaCotacaoVisualizaVM.some(row => row[property]);
  }
  recuperarIdCotacao(): string {
    this.idCotacao = this._activatedRoute.snapshot.paramMap.get('idCotacao')?.toString();
    return this.idCotacao;
  }
  calcularTotal(valores: any[]) {
    return valores.reduce((acc, valor) => acc + valor.valorTotalVidas, 0);
  }

  private formatarDataParaComparacao(data: any): string {
    return data.toISOString().split('T')[0]; // Formato YYYY-MM-DD
  }
  private limparValidacao(): void {
    localStorage.removeItem('validacaoCotacao');
  }

  private salvarValidacaoTemporaria(): void {
    const agora = new Date();
    const expiracao = new Date(agora.getTime() + 60 * 60 * 1000); // 1 hora a partir de agora

    const validacao = {
      expiracao: expiracao.getTime(),
      idCotacao: this.idCotacao,
    };

    localStorage.setItem('validacaoCotacao', JSON.stringify(validacao));
  }

  private validacaoEstaAtiva(): boolean {
    const validacaoStr = localStorage.getItem('validacaoCotacao');
    if (!validacaoStr) return false;

    try {
      const validacao = JSON.parse(validacaoStr);
      const agora = new Date().getTime();

      // Verifica se a validação é para a cotação atual e se ainda não expirou
      return validacao.idCotacao === this.idCotacao && validacao.expiracao > agora;
    } catch (e) {
      return false;
    }
  }

  limparValidacaoAniversario(): void {
    this.limparValidacao();
    this.toastr.info('Validação de aniversário foi reiniciada');
  }

  confirmarAniversario(): void {
    if (!this.dataNascimento) {
      this.toastr.warning('Por favor, informe a data de nascimento');
      return;
    }

    const dataFormatada = this.formatarDataParaComparacao(this.dataNascimento);

    if (dataFormatada) {
      this.salvarValidacaoTemporaria();
      this.toastr.success('Data de nascimento confirmada com sucesso!');
      this.modalAuthDataNascimentoRef.hide();
      this.deveAbrirModal = false;
    } else {
      this.toastr.warning('Não existe cotação ativa para a data de nascimento informada');
      this.dataNascimento = '';
    }
  }

  abrirModalAniversario(idCotacao?: any) {
    this.modalAuthDataNascimentoRef = this._modalService.show(this.modalAuthDataNascimento, {
      backdrop: 'static',
      class: 'modal-md',
      id: 'modalAuthDataNascimento',
      ignoreBackdropClick: true,
    });
    this.modalAuthDataNascimentoRef?.content?.cancel?.pipe(takeUntil(this.destroy$))?.subscribe(() => {});
  }

  decline(): void {
    this.modalAuthDataNascimentoRef?.hide();
  }
  fecharRede(): void {
    this.modalRedeRef?.hide();
  }

  abrirModalLink(): void {
    this.urlAtual = window.location.href;
    this.linkCopiado = false;
    this.modalLinkRef = this._modalService.show(this.modalLink, {
      class: 'modal-dialog-centered',
    });
  }

  fecharModalLink(): void {
    this.modalLinkRef?.hide();
    this.linkCopiado = false;
  }

  copiarLink(inputElement: HTMLInputElement): void {
    inputElement.select();
    document.execCommand('copy');
    this.linkCopiado = true;
    this.toastr.success('Link copiado com sucesso!');
    setTimeout(() => {
      this.linkCopiado = false;
    }, 3000);
  }

  abrirRede(row: any) {
    this.listaModal = row;
    this.modalRedeRef = this._modalService.show(this.redeCredenciada, {
      class: 'modal-xl modal-dialog-centered',
      backdrop: 'static',
      keyboard: true,
      initialState: {
        data: row,
      },
    });
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  abrirModalInformacoes() {
    this.modalInformacoes = this._modalService.show(this.modalMaisInformacoes, {
      backdrop: 'static',
      class: 'modal-xl',
      id: 'modalMaisInformacoes',
    });
  }

  fecharModalInformacoes() {
    this.modalInformacoes.hide();
  }

  isOdonto(): boolean {
    return TipoProduto_E_OperadoraComponent.isOdonto(this.tipoProduto);
  }

  criarTabelaComparacaoPlanos(): string {
    const planos = this.listaCotacaoVisualizaVM;
    const numPlanos = planos.length;

    // Para impressão, divide os planos em grupos de 6
    const gruposPlanos = this.dividirPlanosEmGrupos(planos, 5); // 5 planos por página para caber melhor

    let html = `
    <div style="margin-bottom: 30px;">
      <h3 style="color: #1e3c72; margin-bottom: 15px; font-size: 18px;">📊 Comparação de Planos</h3>
  `;

    // Gera uma tabela para cada grupo de planos
    gruposPlanos.forEach((grupo, grupoIndex) => {
      if (grupoIndex > 0) {
        html += `<div style="page-break-before: always; break-before: page; margin-top: 20px;"></div>`;
      }
      const colWidth = Math.floor(85 / grupo.length);

      html += `
      <div style="page-break-inside: avoid;">
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #dee2e6; font-size: 11px;">
          <thead>
            <tr style="background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%); color: white;">
              <th style="padding: 8px; text-align: left; width: 15%;">Características</th>
              ${grupo
                .map(
                  (plano, index) => `
                <th style="padding: 7px; text-align: center; width: ${colWidth}%; border-left: 1px solid rgba(255,255,255,0.2);">
                  <div style="font-size: 9px; font-weight: normal;">GEIA - ${this.truncarTexto(plano.entidade, 30)}</div>
                  <div style="font-size: 7px; font-weight: 500; opacity: 0.9;">${this.truncarTexto(plano.produto, 40)}</div>
                </th>
              `,
                )
                .join('')}
            </tr>
          </thead>
          <tbody>
            <!-- Valor -->
            <tr style="background: #f8f9fc;">
              <td style="padding: 6px 8px; border: 1px solid #dee2e6;"><strong>💵 Valor</strong></td>
              ${grupo
                .map(
                  plano => `
                <td style="padding: 6px 8px; text-align: center; border: 1px solid #dee2e6;">
                  <span style="font-size: 13px; font-weight: bold; color: #1e3c72;">${this.formatarMoeda(plano.valorTotal)}</span>
                </td>
              `,
                )
                .join('')}
            </tr>
            <!-- Modalidade -->
            <tr>
              <td style="padding: 6px 8px; border: 1px solid #dee2e6;"><strong>📋 Modalidade</strong></td>
              ${grupo
                .map(
                  plano => `
                <td style="padding: 6px 8px; text-align: center; border: 1px solid #dee2e6;">${this.truncarTexto(plano.modalidade, 20)}</td>
              `,
                )
                .join('')}
            </tr>
            <!-- Acomodação -->
            <tr style="background: #f8f9fc;">
              <td style="padding: 6px 8px; border: 1px solid #dee2e6;"><strong>🏥 Acomodação</strong></td>
              ${grupo
                .map(
                  plano => `
                <td style="padding: 6px 8px; text-align: center; border: 1px solid #dee2e6;">${this.isOdonto() ? '-' : plano.acomodacao || '-'}</td>
              `,
                )
                .join('')}
            </tr>
            <!-- Coparticipação -->
            <tr>
              <td style="padding: 6px 8px; border: 1px solid #dee2e6;"><strong>💰 Coparticipação</strong></td>
              ${grupo
                .map(
                  plano => `
                <td style="padding: 6px 8px; text-align: center; border: 1px solid #dee2e6;">${plano.coparticipacao}</td>
              `,
                )
                .join('')}
            </tr>
            <!-- Hospitais -->
            <tr style="background: #f8f9fc;">
              <td style="padding: 6px 8px; border: 1px solid #dee2e6;"><strong>🏥 Hospitais</strong></td>
              ${grupo
                .map(
                  plano => `
                <td style="padding: 6px 8px; text-align: center; border: 1px solid #dee2e6;">${this.contarHospitais(plano)} unid.</td>
              `,
                )
                .join('')}
            </tr>
            <!-- Laboratórios -->
            <tr>
              <td style="padding: 6px 8px; border: 1px solid #dee2e6;"><strong>🧪 Laboratórios</strong></td>
              ${grupo
                .map(
                  plano => `
                <td style="padding: 6px 8px; text-align: center; border: 1px solid #dee2e6;">${this.contarLaboratorios(plano)} unid.</td>
              `,
                )
                .join('')}
            </tr>
          </tbody>
        </table>
      </div>
    `;
    });

    // Faixas etárias - também divididas
    html += this.criarFaixasEtariasMultiplasPaginas(planos);

    html += `</div>`;
    return html;
  }

  // Método para dividir planos em grupos
  dividirPlanosEmGrupos(planos: any[], tamanhoGrupo: number): any[][] {
    const grupos = [];
    for (let i = 0; i < planos.length; i += tamanhoGrupo) {
      grupos.push(planos.slice(i, i + tamanhoGrupo));
    }
    return grupos;
  }

  // Faixas etárias também divididas em páginas
  criarFaixasEtariasMultiplasPaginas(planos: any[]): string {
    const gruposPlanos = this.dividirPlanosEmGrupos(planos, 4); // 4 planos por página

    let html = '';
    gruposPlanos.forEach((grupo, grupoIndex) => {
      if (grupoIndex > 0) {
        html += `<div style="page-break-before: always; break-before: page;"> </div>`;
        html += `<h3 style="color: #1e3c72; margin-bottom: 12px;  font-size: 16px;">👥 Faixas Etárias  </h3>`;
      } else {
        html += `<h3 style=" margin-top: 10% !important;
   color: #1e3c72; margin-bottom: 12px;  font-size: 16px;">👥 Faixas Etárias </h3>`;
      }

      html += `
      <div style="page-break-inside: avoid;">
        <div style="display: flex; gap: 15px; flex-wrap: wrap;">
          ${grupo
            .map(
              (plano, idx) => `
            <div style="flex: 1; min-width: 200px; border: 1px solid #dee2e6; border-radius: 6px; overflow: hidden;">
              <div style="background: #1e3c72; color: white; padding: 6px 8px; text-align: center; font-size: 11px;">
                ${this.truncarTexto(plano.produto, 25)}
              </div>
              <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
                <tbody>
                  ${plano.valores
                    .map(
                      (faixa: any) => `
                    <tr style="border-bottom: 1px solid #f0f2f5;">
                      <td style="padding: 5px 6px;">${faixa.descricaoGrupoPorIdade}</td>
                      <td style="padding: 5px 6px; text-align: center;">${faixa.totalVida}</td>
                      <td style="padding: 5px 6px; text-align: right;">${this.formatarMoeda(faixa.valorTotalVidas)}</td>
                    </tr>
                  `,
                    )
                    .join('')}
                </tbody>
              </table>
            </div>
          `,
            )
            .join('')}
        </div>
      </div>
    `;
    });

    return html;
  }

  formatarMoeda(valor: number): string {
    if (!valor && valor != 0) return 'R$: 0.00';
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  // Método auxiliar para truncar texto
  truncarTexto(texto: string, limite: number): string {
    if (!texto) return '';
    if (texto.length <= limite) return texto;
    return texto.substring(0, limite) + '...';
  }

  // Header compacto
  criarHeaderPrintCompacto(): string {
    return `
    <div style="margin-bottom: 20px; padding-bottom: 12px; border-bottom: 2px solid #1e3c72;">
      <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
        <div>
          <img src="../../../../../assets/app-assets/images/logo/logo-b-geia.png" style="height: 40px;" alt="GEIA Logo">
        </div>
        <div style="text-align: right;">
          <h3 style="color: #1e3c72; margin: 0; font-size: 16px;">Cotação de Planos de Saúde</h3>
          <p style="color: #6c757d; margin: 3px 0 0; font-size: 10px;">${new Date().toLocaleDateString('pt-BR')}</p>
        </div>
      </div>

      <div style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 12px; background: #f8f9fc; padding: 10px 15px; border-radius: 6px; font-size: 12px;">
        <div><strong>Cliente:</strong> ${this.listaCotacaoVisualizaVM[0]?.cliente || '-'}</div>
        <div><strong>Corretor:</strong> ${this.listaCotacaoVisualizaVM[0]?.corretor || '-'}</div>
        <div><strong>E-mail:</strong> ${this.listaCotacaoVisualizaVM[0]?.email || '-'}</div>
      </div>
    </div>
  `;
  }

  // Comparação das redes credenciadas - cada plano em uma página separada
  criarComparacaoRedesCredenciadas(): string {
    let html = '';

    for (let i = 0; i < this.redesParaImprimir.length; i++) {
      const rede = this.redesParaImprimir[i];

      // Adiciona quebra de página antes de cada rede (exceto a primeira)
      if (i > 0) {
        html += `<div class="nova-pagina" style="page-break-before: always; break-before: page;"></div>`;
      }

      html += `
      <div  style=" margin-top: 2% !important;">
        <div  style="border: 1px solid #dee2e6;   border-radius: 8px; overflow: hidden; margin-bottom: 10px !important;">
          <div style="background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%); color: white; padding: 12px 15px;">
            <div style="font-size: 18px; font-weight: bold;">🏥 Rede Credenciada </div>
            <div style="font-size: 14px; margin-top: 4px;">${rede.produto}</div>
          </div>

          <div style="padding: 20px;">
            <!-- Resumo -->
            <div style="display: flex; gap: 20px; margin-bottom: 25px; background: #f8f9fc; padding: 12px; border-radius: 6px;">
              <div><strong>🏥 Hospitais:</strong> ${rede.totalHospitais} unidades</div>
              <div><strong>🧪 Laboratórios:</strong> ${rede.totalLaboratorios} unidades</div>
            </div>

            <!-- Hospitais completos -->
<div class="zone-group" style="page-break-inside: avoid; break-inside: avoid;"  >
              <div style="font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #1e3c72; border-left: 3px solid #1e3c72; padding-left: 10px;">
                🏥 Hospitais Credenciados (${rede.totalHospitais})
              </div>
              ${this.formatarHospitaisCompletoPrint(rede.hospitalsInZone)}
            </div>
            <!-- Laboratórios -->
            <div style="margin-top:4% !important">
              <div style="font-weight: bold; font-size: 16px; margin-bottom: 15px; color: #1e3c72; border-left: 3px solid #1e3c72; padding-left: 10px;">
                🧪 Laboratórios Credenciados (${rede.totalLaboratorios})
              </div>
              <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                ${rede.laboratories
                  .map(
                    (lab: any) => `
                  <span style="background: #e9ecef; padding: 5px 12px; border-radius: 20px; font-size: 12px;">${lab.name}</span>
                `,
                  )
                  .join('')}
                ${rede.laboratories.length === 0 ? '<span style="color: #6c757d;">Nenhum laboratório cadastrado</span>' : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    }

    return html;
  }

  formatarHospitaisCompletoPrint(hospitalsInZone: any[]): string {
    if (!hospitalsInZone || hospitalsInZone.length === 0) {
      return '<div style="color: #6c757d;">Nenhum hospital cadastrado</div>';
    }

    let html = '<div style="font-size: 13px;">';

    for (let i = 0; i < hospitalsInZone.length; i++) {
      const city = hospitalsInZone[i];
      const cityName = city.cityName || city.zone || 'Localização';
      const stateName = city.stateName ? ` - ${city.stateName}` : '';

      html += `
      <div style="margin-bottom: 3% !important; page-break-inside: avoid; break-inside: avoid;">
        <div style="font-weight: bold; color: #2a5298; margin-bottom: 10px; font-size: 14px; border-bottom: 1px solid #e9ecef; padding-bottom: 5px;">
          📍 ${cityName}${stateName}
        </div>
    `;

      // Hospitais diretos
      if (city.hospitals && city.hospitals.length > 0) {
        html += `<div style="margin-left: 20px; margin-bottom: 12px;">`;
        for (const h of city.hospitals) {
          html += `<div style="margin: 4px 0;">• ${h.name}</div>`;
        }
        html += `</div>`;
      }

      // Hospitais por zona
      if (city.zones && city.zones.length > 0) {
        for (const zone of city.zones) {
          html += `
          <div style="margin: 10px 0 4px 20px; page-break-inside: avoid; break-inside: avoid;">
            <em style="color: #6c757d; font-size: 13px;">📌 ${zone.zone}</em>
          </div>
          <div style="margin-left: 40px; margin-bottom: 12px; page-break-inside: avoid; break-inside: avoid;">
        `;
          if (zone.hospitals && zone.hospitals.length > 0) {
            for (const h of zone.hospitals) {
              html += `<div style="margin: 4px 0;">• ${h.name}</div>`;
            }
          } else {
            html += `<div style="color: #adb5bd; font-style: italic;">Nenhum hospital nesta zona</div>`;
          }
          html += `</div>`;
        }
      }

      html += `</div>`;
    }

    html += `</div>`;
    return html;
  }
  async imprimir() {
    this.iniciarSpinner();

    await this.prepararRedesParaImpressao();
    this.toggleAllExpand('isExpandValores');

    await this.delay(300);

    setTimeout(async () => {
      const printContainer = document.createElement('div');
      printContainer.className = 'print-container';
      printContainer.style.cssText = `
      width: 100%;
      max-width: 1100px;
      margin: 0 auto;
      padding: 15px;
      background: white;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    `;

      // HEADER
      printContainer.innerHTML += this.criarHeaderPrintCompacto();

      // TABELA DE COMPARAÇÃO
      printContainer.innerHTML += this.criarTabelaComparacaoPlanos();

      // REDES CREDENCIADAS (cada uma em página separada)
      if (this.redesParaImprimir.length > 0) {
        // Força quebra de página antes das redes
        printContainer.innerHTML += `<div style="page-break-before: always; break-before: page;"></div>`;
        printContainer.innerHTML += this.criarComparacaoRedesCredenciadas();
      }

      // Adiciona CSS para impressão
      const style = document.createElement('style');
      style.textContent = `
      @media print {
  @page {
    size: A4 landscape;
    margin: 12mm;
  }

  /* NÚMERO DA PÁGINA */
  body::after {
    content: "Página " counter(page);
    position: fixed;
    bottom: 6mm;
    right: 10mm;
    font-size: 10px;
  }

  .print-container {
    margin: 0;
    padding: 0;
  }

  /* FORÇA A NÃO QUEBRA DE TEXTO DENTRO DOS ELEMENTOS */
  .rede-container,
  .plan-card,
  .accordion-section,
  table,
  tr,
  td,
  th {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  /* IMPEDE QUEBRA DE LINHA NO MEIO DO TEXTO */
  p, span, div, li, td, th {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: keep-all !important;
    orphans: 3 !important;
    widows: 3 !important;
  }

  /* EVITA QUEBRA DE LINHA EM TÍTULOS */
  h1, h2, h3, h4, h5, h6 {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  /* EVITA QUEBRA DE LINHA EM TABELAS */
  table {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  tr {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    page-break-after: avoid !important;
  }

  /* GARANTE QUE O TEXTO NÃO QUEBRE NO MEIO */
  .no-break-text {
    white-space: nowrap !important;
  }

  .page-break {
    page-break-before: always !important;
    break-before: page !important;
  }

  .no-break {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  /* FORÇA QUE A ZONA E HOSPITAIS FIQUEM JUNTOS */
  .zone-group {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
     .nova-pagina {
    page-break-before: always!important;
    break-before: page!important;
  }
}
    `;
      printContainer.appendChild(style);

      document.body.appendChild(printContainer);

      html2canvas(printContainer, {
        scale: 2,
        logging: false,
        useCORS: true,
        backgroundColor: '#ffffff',
      })
        .then(canvas => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('l', 'mm', 'a4');
          const pageWidth = 297;
          const pageHeight = 210;
          const imgWidth = pageWidth;
          const imgHeight = (canvas.height * pageWidth) / canvas.width;

          let position = 0;
          let heightLeft = imgHeight;

          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft > 0) {
            pdf.addPage();
            position = heightLeft - imgHeight;
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }

          pdf.save(`cotacao_${this.listaCotacaoVisualizaVM[0]?.cliente}_${new Date().toISOString().slice(0, 10)}.pdf`);

          document.body.removeChild(printContainer);
          this.toggleAllExpand('isExpandValores');
          this.pararSpinner();
        })
        .catch(error => {
          console.error('Erro ao gerar PDF:', error);
          this.pararSpinner();
        });
    }, 300);
  }
  // Método para preparar redes com dados completos
  prepararRedesParaImpressao() {
    this.redesParaImprimir = [];

    for (const row of this.listaCotacaoVisualizaVM) {
      if (!this.isOdonto()) {
        this.redesParaImprimir.push({
          produto: row.produto,
          entidade: row.entidade,
          hospitalsInZone: row.hospitalsInZone || [],
          laboratories: row.laboratories || [],
          totalHospitais: this.contarHospitais(row),
          totalLaboratorios: this.contarLaboratorios(row),
        });
      }
    }
  }

  // Método auxiliar delay
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
